/* eslint-disable no-use-before-define */
import PropTypes from 'prop-types';
import {
  Drawer,
  Hidden,
  Box,
  List,
  makeStyles,
} from '@material-ui/core';
import LabelItem from './labelItem';

const useStyles = makeStyles(() => ({
  drawerDesktopRoot: {
    width: 210,
    height: "100%",
    flexShrink: 0,
    '@media (max-width: 1279px)': {
      width: "auto",
    },
    '@media (max-width: 3840px)': {
      width: "auto",
    },
  },
  drawerDesktopPaper: {
    position: 'relative',
    zIndex: 1
  },
  drawerMobilePaper: {
    position: 'relative',
    width: 210
  },
  drawerMobileBackdrop: {
    position: 'absolute'
  }
}));

const labels = [
  // {
  //   id: 'account',
  //   name: 'Account',
  //   img1: '/assets/icons/profile1.svg',
  //   img2: '/assets/icons/profile2.svg'
  // },
  // {
  //   id: 'preferences',
  //   name: 'Preferences',
  //   img1: '/assets/icons/settings1.svg',
  //   img2: '/assets/icons/settings2.svg'
  // },
  // {
  //   id: 'notifications',
  //   name: 'Notifications',
  //   img1: '/assets/icons/bell1.svg',
  //   img2: '/assets/icons/bell2.svg'
  // },
  {
    id: 'user',
    name: 'Users',
    img1: '/assets/icons/profile1.svg',
    img2: '/assets/icons/profile2.svg'
  },
  // {
  //   id: 'billing',
  //   name: 'Billing',
  //   img1: '/assets/icons/invoice1.svg',
  //   img2: '/assets/icons/invoice2.svg'
  // },

];


function Sidebar({ containerRef, sidebarOpen, closeSidebar, billingdetails }: any) {
  const classes = useStyles();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";

  if (billingdetails && billingdetails.data && loginUserData && loginUserData.username) {
    if (labels.filter((lbl: any) => lbl.id == 'billing').length == 0 &&
      (loginUserData?.role_access && loginUserData?.role_access.find((obj: any) => (obj.access_name === 'billing' && obj.access_value === true)))
    ) {
      labels.push(
        {
          id: 'billing',
          name: 'Billing',
          img1: '/assets/icons/invoice1.svg',
          img2: '/assets/icons/invoice2.svg'
        },
      );
    }
  }

  const content = (
    <div>
      <Box py={2} pr={2}>
        <List>
          {labels.map((label) => (
            <LabelItem
              key={label.id}
              label={label}
              onClick={closeSidebar}
            />
          ))}
        </List>
      </Box>
    </div>
  );

  const longElement = <Drawer
    variant="permanent"
    classes={{
      root: classes.drawerDesktopRoot,
      paper: classes.drawerDesktopPaper
    }}
  >
    {content}
  </Drawer>

  const shortElement = <Drawer
    variant="temporary"
    open={sidebarOpen}
    onClose={closeSidebar}
    classes={{
      paper: classes.drawerMobilePaper
    }}
    style={{ position: 'absolute', zIndex: 1200 }}
    BackdropProps={{ classes: { root: classes.drawerMobileBackdrop } }}
    ModalProps={{ container: () => containerRef.current }}
  >
    {content}
  </Drawer>

  return (
    <>
      <Hidden {...{ children: longElement, smDown: true }} />
      <Hidden {...{ children: shortElement, mdUp: true }} />
    </>
  );
}

Sidebar.propTypes = {
  containerRef: PropTypes.any.isRequired,
  closeSidebar: PropTypes.func,
  sidebarOpen: PropTypes.bool,
  billingdetails: PropTypes.any
};

export default Sidebar;
